import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "38",
  fill: "#f59602",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Default View\"><path data-name=\"Path 7362\" class=\"cls-1\" d=\"M8.506 11.007a.906.906 0 0 0-.346-.072H3.629a.906.906 0 1 0 0 1.812h2.347l-5.708 5.7a.91.91 0 1 0 1.287 1.288l5.7-5.708v2.347a.906.906 0 0 0 1.812 0v-4.53a.92.92 0 0 0-.562-.834z\"></path><path data-name=\"Path 7363\" class=\"cls-1\" d=\"M11.498 8.991a.906.906 0 0 0 .344.072h4.53a.906.906 0 0 0 0-1.812h-2.347l5.708-5.7A.91.91 0 0 0 18.446.264l-5.7 5.708V3.628a.906.906 0 1 0-1.812 0v4.53a.92.92 0 0 0 .562.834z\"></path><path data-name=\"Path 7364\" class=\"cls-1\" d=\"M.911 8.158a.906.906 0 0 0 .906-.906V1.816h5.436a.906.906 0 1 0 0-1.812H.911A.906.906 0 0 0 .005.91v6.342a.906.906 0 0 0 .906.906z\"></path><path data-name=\"Path 7365\" class=\"cls-1\" d=\"M19.09 11.841a.906.906 0 0 0-.906.906v5.436h-5.436a.906.906 0 0 0 0 1.812h6.342a.906.906 0 0 0 .906-.906v-6.342a.906.906 0 0 0-.906-.906z\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };